import { Flex, Menu, MenuButton, MenuList, MenuItem } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useResource } from "hooks/resources/providers/resourceProvider";

type DataTableRowActionsProps = {
  item: unknown;
};

export function DataTableRowActions({ item }: DataTableRowActionsProps) {
  const { actions, modal } = useResource<unknown>();

  return (
    <Flex justifyContent="center" alignItems="center" color="gray.200">
      <Menu>
        <MenuButton aria-label="Options" w="20px">
          <FontAwesomeIcon icon={["far", "ellipsis-vertical"]} />
        </MenuButton>
        <MenuList>
          <MenuItem
            icon={<FontAwesomeIcon icon={["far", "pencil"]} />}
            onClick={() => modal.handleOpenModal(item)}
          >
            Edit
          </MenuItem>
          <MenuItem
            icon={<FontAwesomeIcon icon={["far", "trash-can"]} />}
            onClick={() => actions.deleteItem((item as any).id)}
          >
            Delete
          </MenuItem>
        </MenuList>
      </Menu>
    </Flex>
  );
}
